import { render, staticRenderFns } from "./ViewRequestLogComponent.vue?vue&type=template&id=754aa9b1&scoped=true"
import script from "./ViewRequestLogComponent.vue?vue&type=script&lang=js"
export * from "./ViewRequestLogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754aa9b1",
  null
  
)

export default component.exports